import type { Span } from '@wiztime/core';

/** Two spans cover the same minutes (or both are null). */
export const sameSpan = (a: Span | null, b: Span | null): boolean =>
  a === b || (a !== null && b !== null && a.startMin === b.startMin && a.endMin === b.endMin);
